// useMerchant — TanStack Query hook for a single merchant by id OR slug.
//
// The URL identifier coming from the router is opaque to us — could be the
// integer id (legacy) or the slug (recommended). We pass it through to the
// backend which resolves either form to the internal int8 id.
//
// queryKey is per-identifier so each merchant's record is cached
// independently. Disabled until an identifier is known.
import { useQuery } from "@tanstack/react-query";

import { getMerchant } from "@/api/merchants";
import { useAuth } from "@/store/auth";

export function useMerchant(idOrSlug: number | string | undefined) {
  const status = useAuth((s) => s.status);

  return useQuery({
    queryKey: ["merchant", idOrSlug],
    queryFn: () => getMerchant(idOrSlug!),
    enabled: status === "authenticated" && idOrSlug != null,
    staleTime: 60_000,
  });
}
